import { render, staticRenderFns } from "./create.layout.vue?vue&type=template&id=20cc2c4a&scoped=true"
import script from "./create.layout.vue?vue&type=script&lang=js"
export * from "./create.layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cc2c4a",
  null
  
)

export default component.exports